export * from './credit-vetting-score-config.component';
export * from './credit-vetting-score-config-view.component';